import { render } from "./ClientSlider.vue?vue&type=template&id=568e3fd0&scoped=true"
import script from "./ClientSlider.vue?vue&type=script&lang=js"
export * from "./ClientSlider.vue?vue&type=script&lang=js"

import "./ClientSlider.vue?vue&type=style&index=0&id=568e3fd0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-568e3fd0"

export default script